module.exports = __webpack_public_path__ + "img/09-payroll-draft.37bde49d.png";